import { render, staticRenderFns } from "./Form8Layout.vue?vue&type=template&id=6f04b614&scoped=true"
import script from "./Form8Layout.vue?vue&type=script&lang=ts"
export * from "./Form8Layout.vue?vue&type=script&lang=ts"
import style0 from "@/styles/_pdf.scss?vue&type=style&index=0&id=6f04b614&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f04b614",
  null
  
)

export default component.exports